import voxAppicon from "../Assets/images/VoxApp-Icon.png";
import logo from "../Assets//images/logo.png";
import "../Style/scss/pages/login.scss";
import { useEffect, useState } from "react";
import { emailValidation, passwordValidation } from "../Common/Validations";
import { OpenEye } from "../Assets/svgs/OpenEye";
import { GoogleIcon } from "../Assets/svgs/GoogleIcon";
import { SignInBanner } from "./SIgnInBanner";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { LinkedInIcon } from "../Assets/svgs/LinkedIn";
import { InstaIcon } from "../Assets/svgs/InstaIcon";
import { TwitterIcon } from "../Assets/svgs/TwitterIcon";
import { FacebbokIcon } from "../Assets/svgs/FacebookIcon";
import { useDispatch } from "react-redux";
import { userSignIn } from "../Redux/Slice/Authentication/SignInSlice";
import { ErrorModel } from "../Model/ErrorModel";
import { CloseEye } from "../Assets/svgs/CloseEye";
import { Loader } from "../Common/Loader";
import { GoogleLogin, useGoogleLogin } from "@react-oauth/google";
import { googleLogin } from "../Redux/Slice/Authentication/GoogleLoginSlice";
import { saveCurrentUserData } from "../Redux/Slice/Common/CurrentUserSlice";
import { SuccessModel } from "../Model/SuccessModel";
import { SOCIAL_URL } from "../Common/Constants";
import { Tooltip } from "@mui/material";

export const SignIn = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [userCredentials, setUserCredentials] = useState({
    email: "",
    password: "",
  });

  const [formError, setFormError] = useState({
    emailError: "",
    passwordError: "",
  });
  const [errorModel, setErrorModel] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [passwordType, setPasswordType] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [profile, setProfile] = useState(false);
  const [successModal, setSuucessModal] = useState(false);
  const [successMessage, setSucessMessage] = useState("");
  const redirectUrl = location?.state?.redirectUrl;
  const handleChange = (e) => {
    let { name, value } = e.target;
    if (name === "password") {
      const validPassword = passwordValidation(value);
      if (validPassword || value === "") {
        setUserCredentials({ ...userCredentials, [name]: value.trimStart() });
        setFormError({ ...formError, passwordError: "" });
      } else {
        setFormError({
          ...formError,
          passwordError: "Please enter valid password",
        });
        setUserCredentials({ ...userCredentials, [name]: value.trimStart() });
      }
    } else if (name === "email") {
      value = value.trim();
      const validEmail = emailValidation(value);
      if (validEmail || value === "") {
        setUserCredentials({ ...userCredentials, [name]: value.trimStart() });
        setFormError({ ...formError, emailError: "" });
      } else {
        setFormError({ ...formError, emailError: "Please enter valid email" });
        setUserCredentials({ ...userCredentials, [name]: value.trimStart() });
      }
    }
  };

  const handleSubmit = async () => {
    setIsLoading(true);
    const result = await dispatch(userSignIn(userCredentials));

    if (
      userSignIn.fulfilled.match(result) &&
      result?.payload?.success === true
    ) {
      if (result.payload?.data?.access_token) {
        setIsLoading(false);
        localStorage.setItem("userData", JSON.stringify(result.payload.data));
        dispatch(saveCurrentUserData(result?.payload?.data));
        setSucessMessage("Sign in Successfully!");
        setSuucessModal(true);
        setTimeout(() => {
          if (result?.payload?.data?.role?.name === "superadmin") {
            navigate(redirectUrl ?? "/dashboard");
          } else {
            const isPaymentMethodAdded = result?.payload?.data?.customer
              ? result?.payload?.data?.customer?.isPaymentMethodAdded
              : true;
            if (!isPaymentMethodAdded) {
              navigate("/free-trial", {
                state: {
                  redirectUrl,
                },
              });
            } else {
              navigate(redirectUrl ?? "/dashboard");
            }
          }
        }, 1500);
      } else if (result.payload?.data?.otpToken) {
        navigate("/otpverification", {
          state: {
            email: userCredentials.email,
            otpToken: result.payload?.data?.otpToken,
            redirectUrl,
          },
        });
      } else if (result.payload?.data?.isMfaSecretGenerated === true) {
        setIsLoading(false);
        navigate("/otpVerification", {
          state: {
            email: userCredentials.email,
            isMfaEnabled: true,
            redirectUrl,
          },
        });
      } else {
        setIsLoading(false);
        navigate("/qr-scanner", {
          state: {
            email: userCredentials.email,
            mfaCredToken: result?.payload?.data?.mfaCredToken,
            redirectUrl,
          },
        });
      }
    } else {
      setIsLoading(false);
      if (result?.payload?.error?.message === "MFA required") {
        navigate("/qr-scanner", {
          state: { email: userCredentials.email, redirectUrl },
        });
      } else {
        setErrorMessage(result?.payload?.error?.message);
        setErrorModel(true);
        setTimeout(() => {
          setErrorModel(false);
        }, 1500);
      }
    }
  };

  const [user, setUser] = useState();
  useEffect(() => {
    if (user) {
      GoogleSign(user.access_token);
    }
  }, [user]);

  const GoogleSign = async (userToken) => {
    const result = await dispatch(googleLogin({ token: userToken }));
    if (
      googleLogin.fulfilled.match(result) &&
      result?.payload?.success === true
    ) {
      setIsLoading(false);
      if (result.payload?.data?.access_token) {
        localStorage.setItem("userData", JSON.stringify(result.payload.data));
        dispatch(saveCurrentUserData(result?.payload?.data));
        setSucessMessage("Sign in Successfully!");
        setSuucessModal(true);
        setTimeout(() => {
          if (result?.payload?.data?.role?.name === "superadmin") {
            navigate(redirectUrl ?? "/dashboard");
          } else {
            const isPaymentMethodAdded = result?.payload?.data?.customer
              ? result?.payload?.data?.customer?.isPaymentMethodAdded
              : true;
            if (!isPaymentMethodAdded) {
              navigate("/free-trial", {
                state: {
                  redirectUrl,
                },
              });
            } else {
              navigate(redirectUrl ?? "/dashboard");
            }
          }
        }, 1500);
      } else if (result.payload?.data?.otpToken) {
        navigate("/otpverification", {
          state: {
            email: result?.payload?.data?.email,
            otpToken: result.payload?.data?.otpToken,
            redirectUrl,
          },
        });
      } else if (result.payload?.data?.isMfaSecretGenerated === true) {
        setIsLoading(false);
        navigate("/otpVerification", {
          state: {
            email: result?.payload?.data?.email,
            isMfaEnabled: true,
            redirectUrl,
          },
        });
      } else {
        setIsLoading(false);
        navigate("/qr-scanner", {
          state: {
            email: result?.payload?.data?.email,
            mfaCredToken: result?.payload?.data?.mfaCredToken,
            redirectUrl,
          },
        });
      }
    } else {
      setErrorMessage(result?.payload?.error?.message);
      setErrorModel(true);
      setTimeout(() => {
        setErrorModel(false);
      }, 1500);
    }
  };
  const LoginWithGoogle = useGoogleLogin({
    onSuccess: (codeResponse) => setUser(codeResponse),
    onError: (error) => console.error("Login Failed:", error),
  });

  const isFormDisabled =
    userCredentials.email.trim() === "" ||
    userCredentials.password.trim() == "" ||
    formError.emailError != "" ||
    formError.passwordError != "";

  useEffect(() => {
    const listener = (event) => {
      if (event.code === "Enter" || event.code === "NumpadEnter") {
        event.preventDefault();
        if (!isFormDisabled) {
          handleSubmit();
        }
      }
    };
    document.addEventListener("keydown", listener);
    return () => {
      document.removeEventListener("keydown", listener);
    };
  }, [isFormDisabled]);

  return (
    <section className="signup">
      {isLoading ? <Loader /> : ""}

      <div className="signup__flex">
        <SignInBanner />
        <div className="signup__item signup__item--form">
          {/* <div className="signup__mainHeader">
            <div className="branding">
              <div className="branding__logo">
                <img
                  src={logo}
                  alt="Logo | Vox App"
                  className="branding__logo__img"
                />
              </div>
            </div>
          </div> */}
          <div className="signup__form">
            <div className="signup__form__header">
              <div className="branding">
                <div className="branding__logo">
                  <img
                    src={logo}
                    alt="Logo | Vox App"
                    className="branding__logo__img"
                  />
                </div>
                <div className="branding__info">
                  <h1 className="title title--h1">Sign in</h1>
                </div>
                <button
                  className="btn btn__white btn--full"
                  onClick={LoginWithGoogle}
                >
                  Sign in account with Google
                  <GoogleIcon />
                </button>
                <div className="signup__form--divider">
                  <span>Or</span>
                </div>
              </div>
            </div>
            <div className="signup__form__body">
              <div className="form__group">
                <label for="email" className="form__label">
                  Email Address
                </label>
                <div className="form__groupField">
                  <input
                    type="text"
                    id="email"
                    className="form__input"
                    onChange={handleChange}
                    autoComplete="off"
                    name="email"
                    maxLength={100}
                    value={userCredentials.email}
                    placeholder="Enter your email address"
                  />
                </div>
                <div className="form__error">{formError.emailError}</div>
              </div>
              <div className="form__group">
                <label for="password" className="form__label">
                  Password
                </label>
                <div className="form__groupField">
                  <input
                    type={passwordType ? "text" : "password"}
                    id="password"
                    className="form__input"
                    onChange={handleChange}
                    autoComplete="off"
                    name="password"
                    value={userCredentials.password}
                    maxLength={16}
                    placeholder="Enter your password"
                  />
                  <button
                    className="btn"
                    onClick={(e) => {
                      setPasswordType(!passwordType);
                    }}
                  >
                    {passwordType ? <OpenEye /> : <CloseEye />}
                  </button>
                  <button className="btn"></button>
                </div>
                <div className="form__error">{formError.passwordError}</div>
                <div className="form__optInfo text-right">
                  <p className="para">
                    <a
                      onClick={() => {
                        navigate("forgotPassword");
                      }}
                      className="link"
                    >
                      Forgot password?
                    </a>
                  </p>
                </div>
              </div>
              <div className="form__button">
                <button
                  className="btn btn__mintGreen btn--full"
                  disabled={isFormDisabled}
                  type="submit"
                  onClick={handleSubmit}
                >
                  Sign in
                </button>
              </div>
            </div>
            <div className="signup__form__footer">
              <p className="para para--center">
                Don’t have an account?
                <a
                  className="link link__primary"
                  onClick={() => {
                    navigate("/signup");
                  }}
                >
                  Register
                </a>
              </p>
              <ul className="socialLink">
                <li className="socialLink__item">
                  <Tooltip title="Facebook" placement="top" arrow>
                    <a
                      className="socialLink__link"
                      target="_blank"
                      href={SOCIAL_URL.facebook}
                    >
                      <FacebbokIcon />
                    </a>
                  </Tooltip>
                </li>
                <li className="socialLink__item">
                  <Tooltip title="X" placement="top" arrow>
                    <a
                      className="socialLink__link"
                      target="_blank"
                      href={SOCIAL_URL.x}
                    >
                      <TwitterIcon />
                    </a>
                  </Tooltip>
                </li>
                <li className="socialLink__item">
                  <Tooltip title="Instagram" placement="top" arrow>
                    <a
                      className="socialLink__link"
                      target="_blank"
                      href={SOCIAL_URL.instagram}
                    >
                      <InstaIcon />
                    </a>
                  </Tooltip>
                </li>
                <li className="socialLink__item">
                  <Tooltip title="Linkedin" placement="top" arrow>
                    <a
                      className="socialLink__link"
                      target="_blank"
                      href={SOCIAL_URL.linkedin}
                    >
                      <LinkedInIcon />
                    </a>
                  </Tooltip>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      {successModal ? <SuccessModel message={successMessage} /> : ""}
      {errorModel ? <ErrorModel message={errorMessage} /> : ""}
    </section>
  );
};
